/// <reference types="vite/client" />
import { getEnv } from '@schooly/utils/runtime-env';

export const THREAD_API_URL = getEnv('VITE_THREAD_API_URL');
export const SCHOOLY_API_V2_URL = getEnv('VITE_SCHOOLY_API_V2_URL');
